export default {
    ca: {
        title: 'Canviar contrasenya',
        messageOk: 'Contrasenya actualitzada amb exit',
        messageError: 'No s\'ha pogut canviar la contrasenya',
        cambiarClau: 'Canviar contrasenya',
        oldpasswordPlaceholder: 'Contrasenya actual',
        passwordPlaceholder: 'Contrasenya nova',
        cofirmPsswPlaceholder: 'Confirmar contrasenya nova',
        passValidation: 'La contrasenya ha de tenir mínim 5 caràcters',
        passEqualValidation: 'La confirmació de la contrasenya no coincideix',
    },
    es: {
        title: 'Cambiar contraseña',
        messageOk: 'Contraseña actualizada con éxito',
        messageError: 'No se ha podido cambiar la contraseña',
        cambiarClau: 'Cambiar contraseña',
        oldpasswordPlaceholder: 'Contraseña actual',
        passwordPlaceholder: 'Nueva contraseña',
        cofirmPsswPlaceholder: 'Confirmar nueva contraseña',
        passValidation: 'La contraseña debe tener al menos 5 caracteres',
        passEqualValidation: 'La confirmación de la contraseña no coincide',
    },
    en: {
        title: 'Change password',
        messageOk: 'Password successfully updated',
        messageError: 'The password could not be changed',
        cambiarClau: 'Change password',
        oldpasswordPlaceholder: 'Current Password',
        passwordPlaceholder: 'New password',
        cofirmPsswPlaceholder: 'Confirm New Password',
        passValidation: 'The password must have at least 5 characters',
        passEqualValidation: 'Password confirmation does not match',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/cambiar-password-modal/cambiar-password-modal-translations.js